import { Avatar, AvatarFallback, AvatarImage } from '@/shared/components/ui'
import { cn } from '@/shared/lib'
import { getIniciaisPrimeiroUltimoNome } from '@/shared/utils'

type AvatarPessoaProps = {
  nome: string
  imagem?: string | null
  className?: string
}

export function AvatarPessoa({ nome, imagem, className }: Readonly<AvatarPessoaProps>) {
  return (
    <Avatar className={cn('h-12 w-12 shrink-0', className)}>
      <AvatarImage src={imagem ?? ''} alt={`Imagem de ${nome}`} className="h-full w-full rounded-full object-cover" />
      <AvatarFallback className="bg-sky-800 text-white">{getIniciaisPrimeiroUltimoNome(nome)}</AvatarFallback>
    </Avatar>
  )
}
